import { useTranslation } from 'react-i18next';

import NotFoundPage from '../not-found/not-found.page';

export const DashboardNotFound = () => {
  const { t } = useTranslation('insights');
  const title = t('dashboardNotFound');
  return <NotFoundPage title={title} />;
};
